import { useState } from 'react'
import { PriceList } from 'models/IProduct'

export interface ProductProps {
  id: number
  name: string
  image: string
  currency: string
  price: string | null
  calories: string | null
  protein: string | null
  carbs: string | null
  fat: string | null
  isPopular: boolean
  isVegan: boolean
  isVegetarian: boolean
  isGlutenFree: boolean
  isHalal: boolean
  priceList: PriceList[] | null
  description: string
  isClickable: boolean
  isAddToCartActive: boolean
}

export const useProduct = (props: ProductProps) => {
  const { isClickable, calories, protein, carbs, fat, isVegan, isVegetarian } = props

  const [showTooltip, setShowTooltip] = useState(false)
  const [isImageViewerOpen, setIsImageViewerOpen] = useState(false)

  const hasNutrition = [calories, protein, carbs, fat].some(
    (val) => Number(val) > 0
  )

  const items = [
    { title: 'CAL', item: calories, unit: ' kcal' },
    { title: 'PRO', item: protein, unit: 'g' },
    { title: 'CARB', item: carbs, unit: 'g' },
    { title: 'FAT', item: fat, unit: 'g' },
  ]

  const handleMouseEnter = () => setShowTooltip(true)
  const handleMouseLeave = () => setShowTooltip(false)

  const handleImageClick = () => {
    if (isClickable) {
      setIsImageViewerOpen(true)
    }
  }

  const handleCloseImageViewer = () => setIsImageViewerOpen(false)

  const plantType = isVegan ? 'vegan' : isVegetarian ? 'vegetarian' : null

  return {
    ...props,
    hasNutrition,
    items,
    showTooltip,
    isImageViewerOpen,
    plantType,
    handleMouseEnter,
    handleMouseLeave,
    handleImageClick,
    handleCloseImageViewer,
  }
}
